var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adTipWrap"},[_c('div',{staticClass:"adItem"},[_c('a',{attrs:{"href":_vm.metaData.url}},[_c('img',{attrs:{"src":_vm.metaData.imgUrls,"alt":""}})]),_c('div',{staticClass:"fork",on:{"click":_vm.closeTip}})])])}
var staticRenderFns = []

export { render, staticRenderFns }